import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { Permission } from '@hdms/shared/common-types';
import { FT_GLOBAL_AUTHORIZATION_MANAGEMENT, PermissionService, UserContextService } from '@hdms/shared/data-access';
import { EnvironmentService, FeatureToggleService } from '@hdms/shared/util-core';

import { FT_AM_ENABLED_FLAG, FT_DIGITAL_PAYMENT, FT_JUMP_TO_BYD, FT_SOFTWARE_SELLING } from '../constants';
import { FinHubPermissions } from '../types/fin-hub-permissions.enum';

@Injectable({
  providedIn: 'root'
})
export class AccessService {
  private readonly environmentService = inject(EnvironmentService);
  private readonly userContext = inject(UserContextService);
  private readonly permService = inject(PermissionService);
  private readonly ftService = inject(FeatureToggleService);

  get isByDesign(): boolean {
    return this.environmentService.isByDesign;
  }

  get includeSoftwareSelling(): boolean {
    return this.ftService.getToggleById(FT_SOFTWARE_SELLING);
  }

  get isDigitalPaymentsEnabled(): boolean {
    return this.ftService.getToggleById(FT_DIGITAL_PAYMENT);
  }

  get isAccountManager(): boolean {
    return this.userContext.isAccountManager;
  }

  get includeQuoteForContract(): boolean {
    return this.isAccountManager && this.isByDesign && this.ftService.getToggleById(FT_JUMP_TO_BYD);
  }

  public isFinHubAccessPermitted$(): Observable<boolean> {
    return this.userContext.update$().pipe(
      map(() => {
        if (this.ftService.getToggleById(FT_GLOBAL_AUTHORIZATION_MANAGEMENT)) {
          return this.permService.checkPermission(FinHubPermissions.ACCESS_FINANCIAL_HUB, true);
        }

        if (!this.ftService.getToggleById(FT_AM_ENABLED_FLAG) || !this.userContext.isAuthorizationManagementEnabled) {
          return true;
        }
        return this.permService.checkPermission(Permission.VIEW_CUSTOMER_SPECIFIC_PRICING);
      })
    );
  }
}
